import { Reducer } from 'redux';
import { LeadsState, LeadsTypes } from './types';

const INITIAL_STATE: LeadsState = {
  data: [],
  hasError: false,
  isLoading: true,
  total: 0,
};

const reducer: Reducer<LeadsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LeadsTypes.LOAD_REQUEST:
      return { ...state, isLoading: true };
    case LeadsTypes.LOAD_ERROR:
      return { ...state, isLoading: false, hasError: true };
    case LeadsTypes.LOAD_SUCCESS:
      return {
        hasError: false,
        isLoading: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    default:
      return state;
  }
};

export default reducer;
